module.exports = __webpack_public_path__ + "static/media/star-icon-inactive.a427c6a2.svg";